module.exports = __webpack_public_path__ + "img/feature14.7c6e479.png";